<firebase-ui
  (signInSuccessWithAuthResult)="successCallback($event)"
  (signInFailure)="errorCallback($event)"
  (uiShown)="uiShownCallback()"></firebase-ui>
